import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { QuickGame } from "@/components/quick/QuickGame";
import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { getGame } from "@/lib/games";
import { ModeSelect } from "@/components/game/ModeSelect";
import { GameLoader } from "@/components/game/GameLoader";
import { ModeBar } from "@/components/game/ModeBar";
import { SlotGame } from "@/components/game/SlotGame";
import { AviatorGame } from "@/components/aviator/AviatorGame";
import { MinesGame } from "@/components/game/MinesGame";
import { PenaltyGame } from "@/components/penalty/PenaltyGame";
import { RouletteGame } from "@/components/casual/RouletteGame";
import { PlinkoGame } from "@/components/casual/PlinkoGame";
import { DiceGame } from "@/components/casual/DiceGame";
import { WheelGame } from "@/components/casual/WheelGame";
import { HiLoGame } from "@/components/casual/HiLoGame";
import { CoinFlipGame } from "@/components/casual/CoinFlipGame";
import { BlackjackGame } from "@/components/casual/BlackjackGame";
import { BaccaratGame, DragonTigerGame } from "@/components/casual/DuelGame";
import { VideoPokerGame } from "@/components/casual/VideoPokerGame";
import { KenoGame } from "@/components/casual/KenoGame";
import { TowerGame } from "@/components/casual/TowerGame";
import { LimboGame } from "@/components/casual/LimboGame";
import { ScratchGame } from "@/components/casual/ScratchGame";

const COMPONENTS = { slot: SlotGame, bonus: SlotGame, aviator: AviatorGame, mines: MinesGame, penalty: PenaltyGame,
  roulette: RouletteGame, plinko: PlinkoGame, dice: DiceGame, wheel: WheelGame, hilo: HiLoGame, coinflip: CoinFlipGame,
  blackjack: BlackjackGame, baccarat: BaccaratGame, dragontiger: DragonTigerGame, videopoker: VideoPokerGame,
  keno: KenoGame, tower: TowerGame, limbo: LimboGame, scratch: ScratchGame, quick: QuickGame };

export default function GameRoom() {
  const { id } = useParams();
  const game = getGame(id);
  const { user, refresh } = useAuth();
  const [mode, setMode] = useState(null);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { setMode(null); setLoaded(false); }, [id]);
  useEffect(() => { window.scrollTo(0, 0); }, [id, mode, loaded]);
  useEffect(() => { if (loaded && !mode && user) refresh(); }, [loaded, mode]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!game) return <Navigate to="/" replace />;
  const Comp = COMPONENTS[game.type];

  return (
    <div className="relative min-h-[calc(100vh-5rem)] overflow-hidden" data-testid="game-page">
      <img src={game.image} alt="" className="fixed inset-0 w-full h-full object-cover opacity-25 blur-md scale-110 pointer-events-none" />
      <div className="fixed inset-0 bg-[#050505]/75 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-2 sm:px-8 py-3 sm:py-8" key={id}>
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors mb-3 sm:mb-6" data-testid="back-to-lobby"><ArrowLeft size={16} /> Lobbiyə qayıt</Link>
        {!loaded ? (
          <GameLoader game={game} onDone={() => setLoaded(true)} />
        ) : !mode ? (
          <ModeSelect game={game} onSelect={setMode} />
        ) : (
          <div className="space-y-3 sm:space-y-5">
            <ModeBar game={game} mode={mode} onChange={() => setMode(null)} />
            <Comp game={game} mode={mode} />
          </div>
        )}
      </div>
    </div>
  );
}
